import { render } from "./OneC.vue?vue&type=template&id=47ccc776&scoped=true&ts=true"
import script from "./OneC.vue?vue&type=script&lang=ts"
export * from "./OneC.vue?vue&type=script&lang=ts"

import "./OneC.vue?vue&type=style&index=0&id=47ccc776&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ccc776"]])

export default __exports__